const getMedcoinsFromNmoPoints = (points: number): string => {
  switch (points) {
    case 18:
      return '500'
    case 36:
      return '1000'
    case 72:
      return '1500'
    case 144:
      return '2500'
    default:
      return '500'
  }
}

export { getMedcoinsFromNmoPoints }
